import { select, put, takeLatest, all } from 'redux-saga/effects';
import { privateCall } from './api.saga';

import { pagesActions } from '../reducers/pages.reducer';

function* getArticles({ payload }) {
	const { page } = payload;

	try {
		const endpoint = yield select(s => s.config.endpoints[page]);
		let response = yield privateCall({ endpoint });

		if (response && Array.isArray(response))
			response = response.sort((a, b) => a.Sort - b.Sort).reverse();

		yield put(pagesActions.getArticlesComplete({
			page,
			response,
		}));
	} catch (e) {}
}

export default function* authSaga() {
	yield all([
		yield takeLatest(pagesActions.getArticles, getArticles),
	]);
}
